<template>
  <div class="qt-wrap">
    <div class="qt-container">
      <div>
        <!-- 滑动按钮配置 -->

        <div class="quanxian">
          <span>微信支持登记入住:</span>
          <div>
            <el-switch v-model="obj.checkin"></el-switch>
          </div>
        </div>
        <div class="quanxian">
          <span>到店支付:</span>
          <div>
            <el-switch v-model="obj.paywaklin"></el-switch>
          </div>
        </div>
        <div class="quanxian">
          <span>会员支付:</span>
          <div>
            <el-switch v-model="obj.paymember"></el-switch>
          </div>
        </div>
        <div class="quanxian">
          <span>微信支付:</span>
          <div>
            <el-switch v-model="obj.paywechat"></el-switch>
          </div>
        </div>

        <div class="quanxian">
          <span>是否有在店服务:</span>
          <div>
            <el-switch v-model="obj.walkinserver"></el-switch>
          </div>
        </div>
        <div class="quanxian">
          <span>登记选房:</span>
          <div>
            <el-switch v-model="obj.waklinchooseroom"></el-switch>
          </div>
        </div>

        <div class="quanxian">
          <span>退房查房:</span>
          <div>
            <el-switch v-model="obj.checkout"></el-switch>
          </div>
        </div>
        <div class="quanxian">
          <span>钟点房预订:</span>
          <div>
            <el-switch v-model="obj.reservehour"></el-switch>
          </div>
        </div>
        <div class="quanxian">
          <span>钟点房登记:</span>
          <div>
            <el-switch v-model="obj.waklinhour"></el-switch>
          </div>
        </div>
        <!-- <div class="quanxian">
          <span>邦威支付(自助机):</span>
          <div>
            <el-switch v-model="obj.bwpay"></el-switch>
          </div>
        </div>
        <div class="quanxian">
          <span>pos支付(自助机):</span>
          <div>
            <el-switch v-model="obj.pospay"></el-switch>
          </div>
        </div>
        <div class="quanxian">
          <span>微信支付(自助机):</span>
          <div>
            <el-switch v-model="obj.wechatpay"></el-switch>
          </div>
        </div>
        <div class="quanxian">
          <span>支付宝支付(自助机):</span>
          <div>
            <el-switch v-model="obj.alipay"></el-switch>
          </div>
        </div> -->
        <div class="quanxian">
          <span>订单支付有效时间:</span>
          <div>
            <input
              type="number"
              class="input"
              v-model="obj.paytime"
              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
            />
            <span style="margin-left: 0.8em">分钟</span>
          </div>
        </div>
        <div class="quanxian">
          <span>微信预定订单来源:</span>
          <div class="option">
            <select v-model="obj.fromwechat">
              <option
                v-for="(item, index) in fromwechatList"
                :value="item.id"
                :key="index"
              >
                {{ item.description }}
              </option>
            </select>
          </div>
        </div>
        <!-- <div class="quanxian">
          <span>自助机预订订单来源:</span>
          <div class="option">
            <select v-model="obj.fromzzj">
              <option
                v-for="(item, index) in fromzzjList"
                :value="item.id"
                :key="index"
              >
                {{ item.description }}
              </option>
            </select>
          </div>
        </div> -->
        <div class="quanxian">
          <span>预订选房:</span>
          <div
            class="fang-wrap"
            v-for="(item, index) in list1"
            :key="index"
            @click="choosList1('list1', item.code, index)"
          >
            <img
              class="fang-check"
              v-if="!item.checked"
              src="../assets/image/check.png"
              alt
            />
            <img
              class="fang-check"
              v-else
              src="../assets/image/checked2.png"
              alt
            />
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div class="buttonBox">
          <div class="button" @click="submit">保存</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getRequest, postRequest } from "@/api/api1.js";
import { vm } from "../main.js";
export default {
  data() {
    return {
      obj: {
        waklinchooseroom: null,
        fromwechat: null,
        fromzzj: null,
      },
      tRoomRate: [],
      value: "",
      clickIndex: 1,
      ddList: [
        {
          name: "微信预订",
          value: "paywechat",
        },
        {
          name: "自助机预订",
          value: "fromwechat",
        },
      ],
      list1: [
        {
          name: "不排房",
          code: 0,
          checked: false,
        },
        {
          name: "自动排房",
          code: 1,
          checked: false,
        },
        {
          name: "可选排房",
          code: 2,
          checked: false,
        },
      ],
      fromwechatList: [],
      listIndex: null,
      list: [],
      tRoomRate: [],
    };
  },
  computed: {
    clickIndex2() {
      return this.$store.state.operationIndex;
    },
    listClick(){
      return this.$store.state.xcxIndex
    }
  },
  watch: {
    clickIndex(val) {
      if (val == 1) {
        this.getData1();
      } else if (val == 2) {
        this.getData2();
      }
    },
  },
  created() {
    this.getXcx();
    this.fromwechatList = this.$store.state.tSysSourceList;
    this.fromzzjList = this.$store.state.tSysSourceList;
    
    // this.getList();
    this.tRoomRate = vm.$store.state.tRoomType;
  },

  methods: {
    getXcx() {
      getRequest("tSysWechatConfig/selectByHotelId").then((res) => {
        
        if (res.status == 200) {
          if(res.data != null){
            this.obj = res.data;
          if (this.obj.checkin == "1") {
            this.obj.checkin = true;
          } else {
            this.obj.checkin = false;
          }
          if (this.obj.paywaklin == "1") {
            this.obj.paywaklin = true;
          } else {
            this.obj.paywaklin = false;
          }
          if (this.obj.paymember == "1") {
            this.obj.paymember = true;
          } else {
            this.obj.paymember = false;
          }
          if (this.obj.paywechat == "1") {
            this.obj.paywechat = true;
          } else {
            this.obj.paywechat = false;
          }
          if (this.obj.walkinserver == "1") {
            this.obj.walkinserver = true;
          } else {
            this.obj.walkinserver = false;
          }
          if (this.obj.checkout == "1") {
            this.obj.checkout = true;
          } else {
            this.obj.checkout = false;
          }
          if (this.obj.reservehour == "1") {
            this.obj.reservehour = true;
          } else {
            this.obj.reservehour = false;
          }
          if (this.obj.waklinchooseroom == "1") {
            this.obj.waklinchooseroom = true;
          } else {
            this.obj.waklinchooseroom = false;
          }

          if (this.obj.waklinhour == "1") {
            this.obj.waklinhour = true;
          } else {
            this.obj.waklinhour = false;
          }
          if (this.obj.bwpay == "1") {
            this.obj.bwpay = true;
          } else {
            this.obj.bwpay = false;
          }

          if (this.obj.pospay == "1") {
            this.obj.pospay = true;
          } else {
            this.obj.pospay = false;
          }
          if (this.obj.wechatpay == "1") {
            this.obj.wechatpay = true;
          } else {
            this.obj.wechatpay = false;
          }

          if (this.obj.alipay == "1") {
            this.obj.alipay = true;
          } else {
            this.obj.alipay = false;
          }
          let wakRoom = Number(this.obj.reservechooseroom);
          this.list1.forEach((item) => {
            if (wakRoom == item.code) {
              item.checked = true;
            } else {
              item.checked = false;
            }
          });
          }
          
        } else {
          vm.$mymessage({
            content: res.message,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
    submit() {
      if (this.obj.checkin == true) {
        this.obj.checkin = 1;
      } else {
        this.obj.checkin = 0;
      }
      if (this.obj.paywaklin == true) {
        this.obj.paywaklin = 1;
      } else {
        this.obj.paywaklin = 0;
      }
      if (this.obj.paymember == true) {
        this.obj.paymember = 1;
      } else {
        this.obj.paymember = 0;
      }
      if (this.obj.paywechat == true) {
        this.obj.paywechat = 1;
      } else {
        this.obj.paywechat = 0;
      }
      if (this.obj.walkinserver == true) {
        this.obj.walkinserver = 1;
      } else {
        this.obj.walkinserver = 0;
      }
      
      if (this.obj.checkout == true) {
        this.obj.checkout = 1;
      } else {
        this.obj.checkout = 0;
      }
      if (this.obj.reservehour == true) {
        this.obj.reservehour = 1;
      } else {
        this.obj.reservehour = 0;
      }
      if (this.obj.waklinhour == true) {
        this.obj.waklinhour = 1;
      } else {
        this.obj.waklinhour = 0;
      }

      if (this.obj.bwpay == true) {
        this.obj.bwpay = 1;
      } else {
        this.obj.bwpay = 0;
      }
      if (this.obj.pospay == true) {
        this.obj.pospay = 1;
      } else {
        this.obj.pospay = 0;
      }
      if (this.obj.wechatpay == true) {
        this.obj.wechatpay = 1;
      } else {
        this.obj.wechatpay = 0;
      }
      if (this.obj.alipay == true) {
        this.obj.alipay = 1;
      } else {
        this.obj.alipay = 0;
      }
      if (this.obj.waklinchooseroom == true) {
        this.obj.waklinchooseroom = "1";
      } else {
        this.obj.waklinchooseroom = "0";
      }
      
      //   return;
      postRequest("tSysWechatConfig/updateTSysWechatConfig", this.obj).then(
        (res) => {
          
          if (res.status == 200) {
            this.getXcx();
            this.$mymessage({
              content: "保存成功",
              type: "success",
              time: 2000,
              hasClose: true,
            });
          } else {
            vm.$mymessage({
              content: res.message,
              type: "error",
              time: 3000,
              hasClose: true,
            });
          }
        }
      );
    },
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.qt-wrap {
  width: 102%;
  margin-left: -1%;
  height: 100%;
  z-index: 9;
  position: relative;
  overflow: hidden;
}
.qt-top {
  width: 100%;
  height: 7%;
  padding: 0 3%;
  /* background: red; */
  /* display: flex; */
  /* justify-content: end; */
  /* align-items: center; */
  text-align: end;
  margin-top: 2%;
}

.qt-top-right div {
  width: 80%;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}

.qtchecked2 {
  background: url(../assets/image/lq-bg2.png);
  color: #fb7a01;
  background-size: 100% 100%;
  font-weight: bolder;
}
.qt-top-right {
  width: 10%;
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
}
.qt-top-left {
  width: 200px;
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
  /* background: red; */
}
.qt-top-left div {
  width: 6em;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;

  cursor: pointer;
}
.qtchecked {
  background: url(../assets/image/lq-bg2.png);
  color: #fb7a01;
  background-size: 100% 100%;
  font-weight: bolder;
}
.qt-container {
  width: 100%;
  height: 100%;
  margin: 0 0 0;
  position: absolute;
  /* top: 8.5%; */
}
.qt-container img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.qt-container > div {
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  position: absolute;
  top: 0;
  border-radius: 2%;
  margin: 3% 0 0 3%;
  width: 93.9%;
  height: 90%;
  /* padding: 4% 6%; */
  overflow: scroll;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.quanxian {
  width: 33%;
  display: flex;
  align-items: center;
  color: #575f6b;
  line-height: 4em;
  font-size: 14px;
}
.qt-container .double {
  width: 66%;
}
.qt-container > div > div span {
  font-size: 0.8em;
  color: #3e444d;
  margin-right: 0.8em;
  width: 15em;
  text-align: right;
  flex-shrink: 0;
}
.fang-wrap {
  margin-right: 0.5em;
  font-size: 0.8em;
  color: #575f6b;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 6.8em;
  margin-right:1rem;
}
.fang-wrap img {
  /* margin-right: 2px !important; */
  cursor: pointer;
}
.fang-wrap p {
  margin-left: 32px;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
  /* width: 120px; */
}
.radio {
  width: 1.2em;
  height: 1.2em;
  box-shadow: none;
  margin-top: 2px;
  margin-right: 1em;
}
.fang-check {
  width: 3em !important;
  height:3em !important;
}
.qt-container .input {
  width: 35%;
  padding-left: 8px;
  border-radius: 3px;
  height: 28px;
  font-size: 14px;
}
.option {
  width: 35%;
  height: 28px;
  /*盒子阴影修饰作用,自己随意*/
  /* box-shadow: 0 0 5px #ccc;*/
  /* box-shadow: 4px 4px 10px #b9ccec, -4px -4px 10px #ffffff; */

  position: relative;
  color: #6d798e;
}
.option select {
  color: #6d798e;
  font-size: 10px;
  border-radius: 3px;
  /*清除select的边框样式*/
  border: none;
  /*清除select聚焦时候的边框颜色*/
  outline: none;
  /*将select的宽高等于div的宽高*/
  width: 100%;
  height: 28px;
  line-height: 28px;
  font-size:14px;

  border: 1px solid #76a8f5;
  outline: none;
  box-shadow: 2px 2px 4px #b1c9f1 inset, -2px -2px 4px #ffffff inset;
  /*隐藏select的下拉图标*/
  /* appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none; */
  /*通过padding-left的值让文字居中*/
  padding-left: 8px;
  cursor: pointer;
  position: absolute;
  top: 0;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
.el-input {
  width: 35%;
  border-radius: 3px;
}
.el-input--prefix /deep/.el-input__inner {
  border-radius: 3px;
  height: 22px;
  width: 100% !important;
  padding-left: 8px;
}
/* input[type="number"] {
    -moz-appearance: textfield;
} */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.time-select {
  z-index: 9999 !important;
}

.sz-datas {
  margin-bottom: 20px;
  box-shadow: 4px 4px 10px #b9ccec, -4px -4px 10px #ffffff;
  padding: 8px 16px;
  border-radius: 10px;
}
.sz-title {
  color: #2c3036;
  font-size: 14px;
  font-weight: bold;
}
.sz-item {
  display: flex;
  width: 80%;
  margin: 0 auto;
}

.sz-item > div {
  width: 50%;
  display: flex;
  align-items: center;
  color: #575f6b;
  font-size: 14px;
  height: 40px;
}
.sz-item > div img {
  cursor: pointer;
}
.sz-item2 > div {
  height: 70px !important;
}
.qt-container2 {
  width: 94%;
  height: 80%;
  margin: 0 0 0;
  position: absolute;
  top: 13.5%;
  left: 3%;
  /* box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff; */
}
.sz-bg {
  width: 60px;
}
.checked {
  box-shadow: 8px 8px 20px #b9ccec inset, -8px -8px 15px #ffffff inset;
  border-radius: 8px;
}
.shuru {
  width: 90%;
  height: 20%;
  display: flex;
}
.shuru > div {
  width: 100%;
  height: 100%;
}
textarea {
  height: 12em;
  width: 100%;
  padding: 20px;
}
.buttonBox {
  width: 100%;
  display: flex;
  justify-content: center;
}
.button {
  width: 135px;
  height: 30px;
  box-shadow: 4px 4px 10px #b9ccec, -4px -4px 10px #ffffff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1471fe;
  color: white;
  cursor: pointer;
  margin-top: 50px;
  /* margin-left: 200px; */
  font-size: 14px;
}
.xcxList {
  width: 100%;
  border-bottom: 1px solid rgb(121, 120, 120);
  padding-bottom: 20px;
  /* height: 10%; */
  display: flex;
  flex-direction: column;
}

.xcx-top-right div {
  /* width: 30%; */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.xcx-top-right {
  /* width: 20%; */
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
}
.xcx-top-right > div {
  cursor: pointer;
  width: 6em;
}
.xcx-top {
  width: 100%;
  height: 50px;
  padding: 0 2%;
  /* background: red; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 2%;
}
.list-wrap {
  width: 100%;
  height: 100%;
  padding: 1%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.list-con-title {
  width: 100%;
  display: flex;
  flex-shrink: 0;
  width: 99%;
  font-size: 16px;
  font-weight: bold;
}
.list-con-title div {
  text-align: center;
  color: #2c3036;
  font-size: 0.8em;
  line-height: 3.2em;
  width: 20%;
}
.list-con-contaniner {
  color: #6d798e;
  font-size: 14px;
  flex: 1;
  overflow: overlay;
}
.zxj-con-item {
  display: flex;
  width: 100%;
  border: 1px solid transparent;
  cursor: pointer;
  width: 99%;
}
.zxj-con-item > div {
  text-align: center;
  line-height: 3em;
  width: 20%;
  overflow: hidden;
}
.list-con-contaniner .zxjchecked {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  border: 1px solid #1471fe;
  border-radius: 10px;
}
.szkfchecked,
.szkfchecked2 {
  background: url(../assets/image/lq-bg2.png);
  color: #fb7a01;
  background-size: 100% 100%;
  font-weight: bolder;
}
</style>